import { render, staticRenderFns } from "./admin-lock.vue?vue&type=template&id=1b3705b4&"
import script from "./admin-lock.vue?vue&type=script&lang=js&"
export * from "./admin-lock.vue?vue&type=script&lang=js&"
import style0 from "./admin-lock.vue?vue&type=style&index=0&id=1b3705b4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports